import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import search from './search'
import property from './property'
import user from './user'
import agent from './agent'
import modal from './modal'
import filter from './filter'
import map from './map'
import compare from './compare'
import propEval from './propEval'
import customPropEval from './customPropEval'
import ui from './ui'
import constants from './constants'
import contacts from './contacts'
import context from './context'
import networks from './networks'
import typeahead from './typeahead'
import error from './error'
import share from './share'
import tour from './tour'
import taxDetail from './taxDetail'

export default history =>
  combineReducers({
    router: connectRouter(history),
    search,
    user,
    agent,
    modal,
    filter,
    map,
    compare,
    propEval,
    customPropEval,
    property,
    ui,
    constants,
    contacts,
    context,
    networks,
    typeahead,
    error,
    share,
    tour,
    taxDetail
  })
